/* Scentimental Bundle Picker Pro
   Trigger buttons + drawer with search/filter/cards.
   Selections are written back into the Simple Bundles app's hidden <select>s so
   the existing inventory/out-of-stock/add-to-cart logic keeps working unchanged.
*/
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  function relocatePicker(root, drawer) {
    // Try to find the cart-add form (Simple Bundles puts its UI inside it).
    // Look for the form's add-to-cart button and put the picker right above it.
    function attempt() {
      var form = document.querySelector(
        'form[action$="/cart/add"]:not([id^="product-form-installment"])'
      );
      if (!form) return false;

      var anchor = form.querySelector('product-variant-picker')
        || form.querySelector('[data-buy-buttons]')
        || form.querySelector('button[type="submit"]')
        || form.querySelector('input[type="submit"]');

      if (!anchor) return false;

      // Move the picker (but NOT the drawer, drawer is fixed-position and
      // lives at the body level)
      if (drawer.parentNode === root) {
        document.body.appendChild(drawer);
      }
      var insertParent = anchor.parentNode;
      if (insertParent && root.parentNode !== insertParent) {
        insertParent.insertBefore(root, anchor);
      }
      return true;
    }

    if (attempt()) return;
    // Retry a few times in case Simple Bundles app needs time to render
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (attempt() || tries > 30) clearInterval(interval);
    }, 300);
  }

  function init() {
    var roots = document.querySelectorAll('[data-section-type="bundle-picker-pro"]');
    if (!roots.length) return;
    roots.forEach(initOne);
  }

  function initOne(root) {
    var sectionId = root.getAttribute('data-section-id');
    var slotCount = parseInt(root.getAttribute('data-slot-count'), 10);
    var targetSize = parseInt(root.getAttribute('data-target-size'), 10) || slotCount;

    var drawer = root.querySelector('[data-bpp-drawer]');
    if (!drawer) return;

    // Relocate the picker into the product form, right before the
    // "Choose All Options" / "Add to Cart" button. This way the picker
    // appears in the natural product-purchase flow regardless of where the
    // section sits in the template's section order.
    relocatePicker(root, drawer);

    // Sort cards alphabetically within each slot panel (server-side they come
    // out in metafield-definition order). Query the DRAWER not the root,
    // because relocatePicker has moved the drawer to document.body.
    drawer.querySelectorAll('.bpp__slot-cards').forEach(function (panel) {
      var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
      cards.sort(function (a, b) {
        var ta = (a.getAttribute('data-search') || '').trim();
        var tb = (b.getAttribute('data-search') || '').trim();
        return ta.localeCompare(tb);
      });
      var empty = panel.querySelector('.bpp__empty');
      cards.forEach(function (c) { panel.insertBefore(c, empty); });
    });

    // Kick off lazy-load of images + tags for the cards in THIS picker's
    // drawer (must happen after sort + relocate so we have a stable DOM).
    // Image lazy-load removed — text-only cards now

    var searchInput = drawer.querySelector('[data-bpp-search]');
    var tabs = drawer.querySelectorAll('[data-bpp-tab]');
    var slotPanels = drawer.querySelectorAll('[data-bpp-slot]');
    var triggers = root.querySelectorAll('[data-bpp-trigger]');
    var closeButtons = drawer.querySelectorAll('[data-bpp-close]');

    // Per-slot selected value, mirrors the Simple Bundles option values
    var selections = new Array(slotCount).fill(null);
    var activeSlot = 0;
    var activeTab = 'all';

    /* ── Helpers ────────────────────────────── */

    function findAppSelect(slotName) {
      // Simple Bundles renders selects with id derived from option name
      // (downcased, spaces → dashes), inside #simple-bundles-options
      var id = (slotName || '').toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
      var selector = '#simple-bundles-options #' + CSS.escape(id) +
                     ', #simple-bundles-io-options #' + CSS.escape(id);
      var sel = document.querySelector(selector);
      if (sel) return sel;
      // Fallback: scan all selects by their label text
      var allSelects = document.querySelectorAll('#simple-bundles-options select, #simple-bundles-io-options select');
      for (var i = 0; i < allSelects.length; i++) {
        var label = document.querySelector('label[for="' + allSelects[i].id + '"]');
        if (label && label.textContent.trim() === slotName) return allSelects[i];
      }
      return null;
    }

    function setAppSelectValue(slotName, value) {
      var sel = findAppSelect(slotName);
      if (!sel) return;
      // Make sure the option exists
      var has = Array.from(sel.options).some(function (o) { return o.value === value; });
      if (!has) {
        // Add the option dynamically (in case the app hasn't rendered it yet)
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        sel.appendChild(opt);
      }
      sel.value = value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function openDrawer(slotIndex) {
      activeSlot = slotIndex;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      // Force reflow then add open class for transition
      drawer.getBoundingClientRect();
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // Show the matching slot's cards, hide others
      slotPanels.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-bpp-slot'), 10);
        p.hidden = (idx !== slotIndex);
      });

      // Update the drawer title + eyebrow per slot
      var slotEl = root.querySelectorAll('.bpp__slot')[slotIndex];
      var slotName = slotEl ? (slotEl.getAttribute('data-slot-name') || '') : '';
      var titleEl = drawer.querySelector('[data-bpp-title]');
      var eyebrowEl = drawer.querySelector('[data-bpp-eyebrow]');
      var ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth'];
      var ordinal = ordinals[slotIndex] || ('#' + (slotIndex + 1));
      if (eyebrowEl) eyebrowEl.textContent = 'Step ' + (slotIndex + 1) + ' of ' + slotCount;
      if (titleEl) {
        // Prefer the slot's own name from the bundle (it's already meaningful);
        // fall back to "Choose Your <Nth> Fragrance" if name is empty.
        titleEl.textContent = slotName || ('Choose Your ' + ordinal + ' Fragrance');
      }

      // Reset filters when opening a fresh slot
      if (searchInput) searchInput.value = '';
      activeTab = 'all';
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-bpp-tab') === 'all'); });

      applyFilters();
      markSelectedCards();
      setTimeout(function () { if (searchInput) searchInput.focus(); }, 220);

      // Filter out draft/archived products on first open of each slot.
      // Checks /products/{handle}.json — 404 or no published_at = remove card.
      if (window._bppFilterDrafts) {
        var panel = drawer.querySelector('[data-bpp-slot="' + slotIndex + '"]');
        if (panel) window._bppFilterDrafts(panel);
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 280);
    }

    function applyFilters() {
      var q = (searchInput && searchInput.value || '').trim().toLowerCase();
      var activePanel = drawer.querySelector('[data-bpp-slot][hidden="false"], [data-bpp-slot]:not([hidden])');
      if (!activePanel) {
        slotPanels.forEach(function (p) {
          if (parseInt(p.getAttribute('data-bpp-slot'), 10) === activeSlot) activePanel = p;
        });
      }
      if (!activePanel) return;

      var cards = activePanel.querySelectorAll('[data-bpp-card]');
      var visibleCount = 0;
      cards.forEach(function (card) {
        var matchTab = true;
        if (activeTab === 'female') matchTab = card.getAttribute('data-gender') === 'female';
        else if (activeTab === 'male') matchTab = card.getAttribute('data-gender') === 'male';
        else if (activeTab === 'unisex') matchTab = card.getAttribute('data-gender') === 'unisex';
        else if (activeTab === 'new') matchTab = card.getAttribute('data-new') === 'true';
        else if (activeTab === 'bestseller') matchTab = card.getAttribute('data-bestseller') === 'true';

        var matchSearch = !q || (card.getAttribute('data-search') || '').indexOf(q) !== -1;
        var show = matchTab && matchSearch;
        card.hidden = !show;
        if (show) visibleCount++;
      });

      var empty = activePanel.querySelector('.bpp__empty');
      if (empty) empty.hidden = visibleCount > 0;
    }

    function markSelectedCards() {
      slotPanels.forEach(function (p) {
        var idx = parseInt(p.getAttribute('data-bpp-slot'), 10);
        var selVal = selections[idx];
        p.querySelectorAll('[data-bpp-card]').forEach(function (c) {
          var isSel = selVal !== null && c.getAttribute('data-value') === selVal;
          c.classList.toggle('is-selected', isSel);
          var btn = c.querySelector('[data-bpp-add]');
          if (btn) btn.textContent = isSel ? 'Selected ✓' : 'Add +';
        });
      });
    }

    function updateTrigger(slotIndex, value, title) {
      var slot = root.querySelectorAll('.bpp__slot')[slotIndex];
      if (!slot) return;
      slot.classList.toggle('is-filled', !!value);
      var selSpan = slot.querySelector('.bpp__trigger-selected');
      if (selSpan) {
        if (value) {
          selSpan.textContent = title || value;
          selSpan.hidden = false;
        } else {
          selSpan.textContent = '';
          selSpan.hidden = true;
        }
      }
      var clearBtn = slot.querySelector('[data-bpp-clear]');
      if (clearBtn) clearBtn.hidden = !value;
    }

    function refreshProgress() {
      var count = selections.filter(function (v) { return v !== null; }).length;
      var pct = Math.min(100, Math.round((count / targetSize) * 100));
      root.querySelectorAll('.bpp__progress-count').forEach(function (el) { el.textContent = count; });
      root.querySelectorAll('.bpp__progress-target').forEach(function (el) { el.textContent = targetSize; });
      // Drive the progress bar via CSS variable for reliability
      root.style.setProperty('--bpp-progress', pct + '%');
      // Drawer footer mirror
      drawer.querySelectorAll('.bpp__progress-count').forEach(function (el) { el.textContent = count; });
    }

    /* ── Wire events ────────────────────────── */

    triggers.forEach(function (btn, i) {
      btn.addEventListener('click', function () { openDrawer(i); });
    });

    // Wire the clear (×) buttons on each slot
    var clearBtns = root.querySelectorAll('[data-bpp-clear]');
    clearBtns.forEach(function (btn, i) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        // Empty the selection for this slot
        selections[i] = null;
        // Reset the underlying Simple Bundles app select to its placeholder
        var slotEl = root.querySelectorAll('.bpp__slot')[i];
        var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
        var sel = findAppSelect(slotName);
        if (sel) {
          sel.selectedIndex = 0;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        updateTrigger(i, null, '');
        refreshProgress();
        markSelectedCards();
      });
    });

    closeButtons.forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });

    if (searchInput) {
      var to;
      searchInput.addEventListener('input', function () {
        clearTimeout(to);
        to = setTimeout(applyFilters, 100);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        activeTab = t.getAttribute('data-bpp-tab');
        applyFilters();
      });
    });

    // Add button delegation
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bpp-add]');
      if (!btn) return;
      var card = btn.closest('[data-bpp-card]');
      if (!card) return;
      var value = card.getAttribute('data-value');
      var title = (card.querySelector('.bpp__card-title') || {}).textContent;

      // Record selection
      selections[activeSlot] = value;

      // Tell the Simple Bundles app via its hidden select
      var slotEl = root.querySelectorAll('.bpp__slot')[activeSlot];
      var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
      setAppSelectValue(slotName, value);

      // Visual updates
      updateTrigger(activeSlot, value, title);
      refreshProgress();
      markSelectedCards();

      // Auto-close + auto-advance to next empty slot if any
      setTimeout(function () {
        closeDrawer();
        var nextEmpty = selections.findIndex(function (v) { return v === null; });
        if (nextEmpty !== -1 && nextEmpty !== activeSlot) {
          setTimeout(function () { openDrawer(nextEmpty); }, 320);
        }
      }, 300);
    });

    // Initial progress render
    refreshProgress();

    // Themed Discovery Sets and similar curated bundles have exactly 1 option
    // per slot. Forcing the customer to "choose" the only available option in
    // every slot is friction with no upside — pre-fill all single-option slots
    // so they land on the page with the bundle ready and just hit Add to Cart.
    var autoFilledAny = false;
    slotPanels.forEach(function (panel) {
      var idx = parseInt(panel.getAttribute('data-bpp-slot'), 10);
      if (selections[idx] !== null) return;
      var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
      if (cards.length !== 1) return;
      var card = cards[0];
      var value = card.getAttribute('data-value');
      var titleEl = card.querySelector('.bpp__card-title');
      var title = titleEl ? titleEl.textContent : value;
      var slotEl = root.querySelectorAll('.bpp__slot')[idx];
      var slotName = slotEl ? slotEl.getAttribute('data-slot-name') : '';
      selections[idx] = value;
      setAppSelectValue(slotName, value);
      updateTrigger(idx, value, title);
      autoFilledAny = true;
    });
    if (autoFilledAny) {
      refreshProgress();
      markSelectedCards();
    }

    // ── Source-of-truth reconciliation ─────────────────────────────────
    // Simple Bundles' setDefaultOptions() auto-fills every hidden <select>
    // with its FIRST real option on init. If a customer picks only some
    // slots, the un-picked selects keep that default — which is why bundles
    // were silently adding to cart as "3 x the same fragrance" (the first
    // option, e.g. Armani My Way) even though the picker showed those slots
    // empty. The picker's selections[] array is the real truth, so we
    // continuously mirror it into the app's selects: empty slots are forced
    // back to the placeholder (so the app's own validator blocks an
    // incomplete add-to-cart) and picked slots are re-applied (so the app
    // can't clobber a genuine choice). Idempotent — only fires a change event
    // when a value has actually drifted, so it is safe to run on a timer.
    function slotNameFor(idx) {
      var slotEl = root.querySelectorAll('.bpp__slot')[idx];
      return slotEl ? slotEl.getAttribute('data-slot-name') : '';
    }
    function reconcileAppSelects() {
      for (var idx = 0; idx < slotCount; idx++) {
        var sel = findAppSelect(slotNameFor(idx));
        if (!sel) continue;
        var want = selections[idx];
        if (want === null) {
          if (sel.selectedIndex !== 0) {
            sel.selectedIndex = 0; // placeholder
            sel.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (sel.value !== want) {
          setAppSelectValue(slotNameFor(idx), want);
        }
      }
    }
    // Run on the app's own init cadence, then keep a light watchdog going so a
    // slow-rendering page (the 100ml bundle) can't sneak a default back in
    // after our last timeout. The app only default-fills once, so the
    // watchdog can stop after 12s.
    [300, 700, 1200, 2000, 3200].forEach(function (ms) { setTimeout(reconcileAppSelects, ms); });
    var reconcileTimer = setInterval(reconcileAppSelects, 700);
    setTimeout(function () { clearInterval(reconcileTimer); }, 12000);

    // ── Add-to-cart guard: warn on an all-identical bundle ──────────────
    // This bundle lets the customer mix different scents at no extra cost, so
    // an all-the-same bundle is almost always a mistake (or the legacy default
    // bug). Before the bundle is added we reconcile once more (last-moment
    // scrub of any stale default) and, if every slot holds the SAME fragrance,
    // ask the customer to confirm. The decision is cached briefly so the
    // paired click + submit events of a single tap don't double-prompt.
    function allSameSelected() {
      if (selections.length < 2) return false;
      var first = selections[0];
      if (first === null) return false;
      return selections.every(function (v) { return v !== null && v === first; });
    }
    function titleForValue(value) {
      var safe = (window.CSS && CSS.escape) ? CSS.escape(value) : value;
      var card = drawer.querySelector('[data-bpp-card][data-value="' + safe + '"]');
      var t = card && card.querySelector('.bpp__card-title');
      return t ? t.textContent.trim() : value;
    }
    var guardDecision = null;   // 'allow' while a modal-confirmed add is in flight
    var guardDecisionAt = 0;
    var guardForm = null;
    var guardBtn = null;

    // Styled confirmation modal (replaces the native browser confirm dialog).
    // Built once, lives at body level above the cart drawer, matched to the
    // picker's look (Cinzel/Jost, red accent).
    var dupModal = (function buildModal() {
      if (!document.getElementById('bpp-dup-style')) {
        var style = document.createElement('style');
        style.id = 'bpp-dup-style';
        style.textContent = [
          '.bpp-modal{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:20px;font-family:\'Jost\',sans-serif;}',
          '.bpp-modal[hidden]{display:none;}',
          '.bpp-modal__backdrop{position:absolute;inset:0;background:rgba(0,0,0,.6);opacity:0;transition:opacity .2s ease;}',
          '.bpp-modal.is-open .bpp-modal__backdrop{opacity:1;}',
          '.bpp-modal__panel{position:relative;width:100%;max-width:420px;background:#fff;border-radius:14px;padding:28px 24px 22px;text-align:center;box-shadow:0 24px 60px rgba(0,0,0,.3);transform:translateY(12px) scale(.98);opacity:0;transition:transform .25s cubic-bezier(.2,.7,.2,1),opacity .25s ease;}',
          '.bpp-modal.is-open .bpp-modal__panel{transform:none;opacity:1;}',
          '.bpp-modal__icon{width:54px;height:54px;margin:0 auto 14px;border-radius:50%;background:#fdecec;color:#c60001;display:flex;align-items:center;justify-content:center;font-size:28px;font-weight:800;line-height:1;}',
          '.bpp-modal__title{font-family:\'Cinzel\',serif;font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:18px;margin:0 0 10px;color:#1a1a1a;}',
          '.bpp-modal__body{font-size:14px;line-height:1.55;color:#4a4a4a;margin:0 0 22px;}',
          '.bpp-modal__body strong{color:#1a1a1a;}',
          '.bpp-modal__actions{display:flex;flex-direction:column;gap:10px;}',
          '.bpp-modal__btn{width:100%;padding:14px 18px;border-radius:10px;cursor:pointer;font-family:\'Jost\',sans-serif;font-size:14px;font-weight:700;letter-spacing:.04em;transition:background .2s ease,transform .15s ease,border-color .2s ease;}',
          '.bpp-modal__btn:active{transform:scale(.98);}',
          '.bpp-modal__btn--primary{background:#c60001;color:#fff;border:2px solid #c60001;}',
          '.bpp-modal__btn--primary:hover{background:#a30001;border-color:#a30001;}',
          '.bpp-modal__btn--ghost{background:#fff;color:#1a1a1a;border:2px solid #e0d8d0;}',
          '.bpp-modal__btn--ghost:hover{border-color:#1a1a1a;}'
        ].join('');
        document.head.appendChild(style);
      }

      var el = document.createElement('div');
      el.className = 'bpp-modal';
      el.setAttribute('data-bpp-modal', '');
      el.hidden = true;
      el.innerHTML =
        '<div class="bpp-modal__backdrop" data-bpp-modal-cancel></div>' +
        '<div class="bpp-modal__panel" role="dialog" aria-modal="true" aria-label="Same fragrance selected">' +
          '<div class="bpp-modal__icon" aria-hidden="true">!</div>' +
          '<h3 class="bpp-modal__title">Same fragrance × ' + slotCount + '</h3>' +
          '<p class="bpp-modal__body" data-bpp-modal-body></p>' +
          '<div class="bpp-modal__actions">' +
            '<button type="button" class="bpp-modal__btn bpp-modal__btn--ghost" data-bpp-modal-keep></button>' +
            '<button type="button" class="bpp-modal__btn bpp-modal__btn--primary" data-bpp-modal-cancel-btn>Change my choices</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);

      var bodyEl = el.querySelector('[data-bpp-modal-body]');
      var keepBtn = el.querySelector('[data-bpp-modal-keep]');
      var onKeep = null, onCancel = null;

      function close() {
        el.classList.remove('is-open');
        setTimeout(function () { el.hidden = true; }, 220);
      }
      function open(opts) {
        bodyEl.innerHTML = opts.body;
        keepBtn.textContent = opts.keepLabel;
        onKeep = opts.onKeep; onCancel = opts.onCancel;
        el.hidden = false;
        el.getBoundingClientRect(); // force reflow for the open transition
        el.classList.add('is-open');
      }
      el.querySelectorAll('[data-bpp-modal-cancel], [data-bpp-modal-cancel-btn]').forEach(function (b) {
        b.addEventListener('click', function () { close(); if (onCancel) onCancel(); });
      });
      keepBtn.addEventListener('click', function () { close(); if (onKeep) onKeep(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.hidden) { close(); if (onCancel) onCancel(); }
      });
      return { open: open, close: close };
    })();

    function guardAddToCart(e) {
      reconcileAppSelects();
      // A modal-confirmed add is currently passing through — let it go.
      if (guardDecision === 'allow' && (Date.now() - guardDecisionAt) < 2000) return;
      if (!allSameSelected()) return;
      // Every slot holds the same fragrance — stop the add and ask first.
      e.preventDefault();
      e.stopImmediatePropagation();
      var name = titleForValue(selections[0]);
      dupModal.open({
        body: 'You have chosen <strong>' + slotCount + ' × ' + name + '</strong>.<br><br>'
          + 'This bundle lets you pick <strong>' + slotCount + ' different scents</strong> at no extra cost. '
          + 'Would you like to keep them all the same?',
        keepLabel: 'Keep ' + slotCount + ' × the same',
        onKeep: function () {
          guardDecision = 'allow';
          guardDecisionAt = Date.now();
          // Re-fire the real add-to-cart; the guard now lets it straight through.
          if (guardBtn) guardBtn.click();
          else if (guardForm && guardForm.requestSubmit) guardForm.requestSubmit();
          else if (guardForm) guardForm.submit();
        },
        onCancel: function () { openDrawer(1); } // reopen so they can change a scent
      });
    }

    (function bindAddToCartGuard() {
      function bind() {
        var form = document.querySelector(
          'form[action$="/cart/add"]:not([id^="product-form-installment"])'
        );
        if (!form) return false;
        if (form.dataset.bppGuardBound === '1') return true;
        form.dataset.bppGuardBound = '1';
        guardForm = form;
        guardBtn = form.querySelector('button[name="add"], [data-buy-buttons] button[type="submit"], button[type="submit"]');
        form.addEventListener('submit', guardAddToCart, true);
        if (guardBtn) guardBtn.addEventListener('click', guardAddToCart, true);
        return true;
      }
      if (bind()) return;
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (bind() || tries > 30) clearInterval(iv);
      }, 300);
    })();
  }

  ready(init);

  /* ── Lazy-load product image + tags per card ─────────
     Called when a card enters the viewport. Uses Shopify's storefront
     /products/{handle}.json (public, no auth) so we don't hit the
     all_products[] cap. Results are cached in sessionStorage so re-opening
     the drawer is instant.
  */
  var enhanceCard = (function () {
    var cache = {};
    try {
      var saved = sessionStorage.getItem('bpp_card_cache');
      if (saved) cache = JSON.parse(saved);
    } catch (_) { /* ignore */ }

    function saveCache() {
      try { sessionStorage.setItem('bpp_card_cache', JSON.stringify(cache)); } catch (_) {}
    }

    function apply(card, data) {
      if (!card) return;
      var img = card.querySelector('[data-bpp-img]');
      if (img && data.image) { img.src = data.image; }

      var gender = 'unisex';
      var tags = (data.tags || '').toLowerCase();
      if (tags.indexOf('female') !== -1) gender = 'female';
      else if (tags.indexOf('male') !== -1) gender = 'male';
      if (tags.indexOf('unisex') !== -1) gender = 'unisex';

      var bestseller = /bestseller|best[- ]?seller/.test(tags);
      var isNew = /newly[- ]added|new arrival/.test(tags);

      card.setAttribute('data-gender', gender);
      card.setAttribute('data-bestseller', bestseller ? 'true' : 'false');
      card.setAttribute('data-new', isNew ? 'true' : 'false');

      var pills = card.querySelector('[data-bpp-pills]');
      if (pills) {
        pills.innerHTML = '<span class="bpp__pill bpp__pill--' + gender + '">' + gender + '</span>' +
          (isNew ? '<span class="bpp__pill bpp__pill--new">New</span>' : '');
      }
      var bs = card.querySelector('[data-bpp-bestseller]');
      if (bs) bs.hidden = !bestseller;
    }

    function fetchAndApply(card) {
      var handle = card.getAttribute('data-handle');
      if (!handle || card.dataset.bppLoaded === '1') return;
      card.dataset.bppLoaded = '1';

      if (cache[handle]) { apply(card, cache[handle]); return; }

      fetch('/products/' + handle + '.json', { cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.product) return;
          var p = d.product;
          var data = {
            image: p.image ? p.image.src : ((p.images || [])[0] || {}).src,
            tags: p.tags || ''
          };
          cache[handle] = data;
          saveCache();
          apply(card, data);
        })
        .catch(function () { /* network blip, leave placeholder */ });
    }

    // Set up an IntersectionObserver per drawer body
    function observe(rootScope) {
      var bodyEl = rootScope.querySelector('.bpp__drawer-body');
      if (!bodyEl || !('IntersectionObserver' in window)) {
        // Fallback: just enhance everything
        rootScope.querySelectorAll('[data-bpp-card]').forEach(fetchAndApply);
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            fetchAndApply(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { root: bodyEl, rootMargin: '200px' });

      rootScope.querySelectorAll('[data-bpp-card]').forEach(function (c) {
        io.observe(c);
      });
    }

    return { observe: observe };
  })();

  // Expose the enhancer so initOne can call it on the drawer (the drawer gets
  // moved to document.body, so the picker init knows where it actually lives
  // and can pass the correct DOM scope).
  window._bppEnhanceObserve = function (scope) {
    enhanceCard.observe(scope);
  };

  // Stagger fetches so we don't fire 800 requests at once. Process up to 8
  // concurrent. Called when a drawer slot panel becomes visible.
  window._bppFetchAll = function (panel) {
    var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
    var queue = cards.filter(function (c) { return c.dataset.bppLoaded !== '1'; });
    if (!queue.length) return;
    var concurrency = 8;
    var inflight = 0;
    var idx = 0;
    function next() {
      while (inflight < concurrency && idx < queue.length) {
        var card = queue[idx++];
        if (!card) continue;
        inflight++;
        var handle = card.getAttribute('data-handle');
        if (!handle) { inflight--; continue; }
        if (card.dataset.bppLoaded === '1') { inflight--; continue; }
        card.dataset.bppLoaded = '1';
        fetch('/products/' + handle + '.json', { cache: 'force-cache' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then((function (c) {
            return function (d) {
              inflight--;
              if (!d || !d.product) { next(); return; }
              var p = d.product;
              var img = c.querySelector('[data-bpp-img]');
              if (img) {
                var src = (p.image && p.image.src) || ((p.images || [])[0] || {}).src;
                if (src) img.src = src;
              }
              next();
            };
          })(card))
          .catch(function () { inflight--; next(); });
      }
    }
    next();
  };

  // Filter out draft / archived products from a slot panel. A product that
  // is set to "Draft" status in Shopify admin returns 404 from the public
  // /products/{handle}.json endpoint; an "Archived" product returns 200 but
  // with published_at: null. Either way, we want it gone from the picker.
  // Results are cached in sessionStorage so we don't refetch on every open.
  window._bppFilterDrafts = function (panel) {
    if (!panel || panel.dataset.bppFiltered === '1') return;
    panel.dataset.bppFiltered = '1';

    var cache = {};
    try { cache = JSON.parse(sessionStorage.getItem('bpp_active_cache') || '{}'); } catch (_) {}

    var cards = Array.from(panel.querySelectorAll('[data-bpp-card]'));
    var concurrency = 6;
    var inflight = 0;
    var idx = 0;

    function saveCache() {
      try { sessionStorage.setItem('bpp_active_cache', JSON.stringify(cache)); } catch (_) {}
    }

    function processNext() {
      while (inflight < concurrency && idx < cards.length) {
        var card = cards[idx++];
        var handle = card.getAttribute('data-handle');
        if (!handle) continue;

        // Cache hit
        if (handle in cache) {
          if (!cache[handle]) card.remove();
          continue;
        }

        inflight++;
        (function (c, h) {
          fetch('/products/' + h + '.json', { cache: 'force-cache' })
            .then(function (r) {
              if (r.status === 404) { return { active: false }; }
              if (!r.ok) { return { active: true }; } // be permissive on transient errors
              return r.json().then(function (d) {
                var active = !!(d && d.product && d.product.published_at);
                return { active: active };
              });
            })
            .then(function (result) {
              cache[h] = result.active;
              saveCache();
              if (!result.active) c.remove();
            })
            .catch(function () {
              // Network blip — leave card visible so we don't accidentally hide everything
            })
            .then(function () {
              inflight--;
              processNext();
            });
        })(card, handle);
      }
    }
    processNext();
  };

  /* Bundle review badge override has moved to assets/bundle-review-badge.js
     which runs globally and overrides by product-ID match — same behaviour
     on PDPs plus also covers collection cards where Fera injects badges
     dynamically after page load. */
})();
